import { jsx as _jsx } from "react/jsx-runtime";
import { AlertOutlinedIcon } from '@getgo/chameleon-icons/react';
import { Alert } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ConversationSource } from "../../state/conversation/types";
import classes from './FacebookAlertEvent.module.scss';
const MINUTES_IN_24_HOURS = 1440;
const SECONDS_IN_24_HOURS = 86400;
const SECONDS_IN_23_HOURS = 82800;
const FacebookAlertEvent = ({ fullWidth, compact, participantWaitTime, source, }) => {
    const { t } = useTranslation();
    let text = null;
    let level = 'info';
    if (participantWaitTime > SECONDS_IN_24_HOURS) {
        level = 'danger';
        text =
            source === ConversationSource.FACEBOOK
                ? t('This conversation has reached the 24 hours delay. You will not be able to send a message from here, you need to reply in Facebook directly.')
                : t('This conversation has reached the 24 hours delay. You will not be able to send a message from here, you need to reply in Instagram directly.');
    }
    else if (participantWaitTime > SECONDS_IN_23_HOURS) {
        level = 'warning';
        const minutesToExpiration = Math.ceil(MINUTES_IN_24_HOURS - participantWaitTime / 60);
        text =
            source === ConversationSource.FACEBOOK
                ? t('This conversation will expire in {{minutesToExpiration}} minutes. After that, you will need to reply in Facebook directly.', { minutesToExpiration })
                : t('This conversation will expire in {{minutesToExpiration}} minutes. After that, you will need to reply in Instagram directly.', { minutesToExpiration });
    }
    return (text && (_jsx("div", Object.assign({ role: "listitem", className: classNames(classes.content, {
            [classes.fullWidth]: fullWidth,
            [classes.compact]: compact,
        }) }, { children: _jsx(Alert, Object.assign({ icon: _jsx(AlertOutlinedIcon, {}, void 0), variant: level }, { children: text }), void 0) }), void 0)));
};
export default FacebookAlertEvent;
//# sourceMappingURL=FacebookAlertEvent.js.map